import React from 'react';
import { useGlobalState } from '../../../hooks/useGlobalState';
import { RouteKeys } from '../../../data/routeKeys';
import './SBSTraining.scss';
import EmailFormGate from '../../organisms/EmailFormGate/EmailFormGate';

// wrapper for the patient training flow

const SBSTraining: React.FC = () => {
  // the flow param fed to useGlobalState is used to determine
  // the active step based on the user's actions and the current module
  // they're viewing
  const { activeStepComponent } = useGlobalState({ flow: RouteKeys.SBS_TRAINING });

  return (
    <div className='SBSTraining__Page'>
      <EmailFormGate>
        {activeStepComponent}
      </EmailFormGate>
    </div>
  );
};

export default SBSTraining;
